import { useFrame, useLoader } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import { Center, Text3D } from "@react-three/drei";
import Rocket from "../meshes/Rocket";
import Ufo from "../meshes/Ufo";
import { animated, useSpring } from "@react-spring/three";
import Star from "../meshes/Stars/Star";
import { useAtom, useAtomValue } from "jotai";
import * as THREE from 'three';
import { alertsAtom, backdoLaunchAtom, currentPlayerNameAtom, gamePhaseAtom, turnAtom, yutMoCatchAtom } from "../GlobalState";
import { formatName } from "../logicHelpers/helpers";
import DoAlert from "../alerts/DoAlert";
import GeAlert from "../alerts/GeAlert";
import GulAlert from "../alerts/GulAlert";
import YootAlert from "../alerts/YootAlert";
import MoAlert from "../alerts/MoAlert";
import OutAlert from "../alerts/OutAlert";
import BackdoAlert from "../alerts/BackdoAlert";
import YootAlertPregame from "../alerts/YootAlertPregame";
import MoAlertPregame from "../alerts/MoAlertPregame";
import { useFireworksShader } from "../shader/fireworks/FireworksShader";
import { useSparkShader } from "../shader/spark/SparkShader";
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { useAnimationPlaying } from "../hooks/useAnimationPlaying";
import CatchRocketMemeAlert from "../alerts/CatchRocketMemeAlert";
import CatchUfoEnergyAlert from "../alerts/CatchUfoEnergyAlert";
import PregameRocketsWinAlert from "../alerts/PregameRocketsWinAlert";
import PregameTieAlert from "../alerts/PregameTieAlert";
import PregameUfosWinAlert from "../alerts/PregameUfosWinAlert";
import ScoreAlert from "../alerts/ScoreAlert";
import TurnAlert from "../alerts/TurnAlert";
import Catch4UfoAlert from "../alerts/Catch4UfoAlert";
import Catch3UfoAlert from "../alerts/Catch3UfoAlert";
import GameStartAlert from "../alerts/GameStartAlert";
import JoinAlert from "../alerts/JoinAlert";
import TimesUpAlert from "../alerts/TimesUpAlert";
import MinigameTimeAlert from "../alerts/MinigameTimeAlert";

export default function Alert({ position, rotation }) {
    
    const alerts = useAtomValue(alertsAtom)
    const [gamePhase] = useAtom(gamePhaseAtom)
    const animationPlaying = useAnimationPlaying()
    const [CreateFirework] = useFireworksShader();
    const [CreateSpark] = useSparkShader();
    const [scoringTeam, setScoringTeam] = useState(-1)
    const [yutMoCatch, setYutMoCatch] = useAtom(yutMoCatchAtom)
    const backdoRule = useAtomValue(backdoLaunchAtom)

    const sparkTexture = useLoader(TextureLoader, '/textures/particles/6.png')

    const [springs, api] = useSpring(() => ({
      from: {
        turnAlertScale: 0,
        gameStartAlertScale: 0,
        yootOutcome1AlertScale: 0,
        yootOutcome2AlertScale: 0,
        yootOutcome3AlertScale: 0,
        yootOutcome4PregameAlertScale: 0,
        yootOutcome5PregameAlertScale: 0,
        yootOutcome4AlertScale: 0,
        yootOutcome5AlertScale: 0,
        yootOutcomeOutAlertScale: 0,
        yootOutcomeBackdoAlertScale: 0,
        pregameTieAlertScale: 0,
        pregameRocketsWinAlertScale: 0,
        pregameUfosWinAlertScale: 0,
        catchAlertScale: 0,
        scoreAlertScale: 0,
        joinAlertScale: 0,
        timesUpAlertScale: 0,
        minigameTimeAlertScale: 0
      },
    }))

    function transformAlertsToAnimations(alerts) {
      let animations = []
      for (let i = 0; i < alerts.length; i++) {
        if (alerts[i] === 'gameStart') {
          animations.push({
            gameStartAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            gameStartAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'turn') {
          animations.push({
            turnAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            turnAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'yootOutcome1') {
          animations.push({
            yootOutcome1AlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome1AlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 500
          })
        } else if (alerts[i] === 'yootOutcome2') {
          animations.push({
            yootOutcome2AlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome2AlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 500
          })
        } else if (alerts[i] === 'yootOutcome3') {
          animations.push({
            yootOutcome3AlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome3AlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 500
          })
        } else if (alerts[i] === 'yootOutcome4Pregame') {
          animations.push({
            yootOutcome4PregameAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome4PregameAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 500
          })
        } else if (alerts[i] === 'yootOutcome5Pregame') {
          animations.push({
            yootOutcome5PregameAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome5PregameAlertScale: 0,
            config: {
                tension: 300,
                friction: 26
            },
            delay: 500
          })
        } else if (alerts[i] === 'yootOutcome4') {
          animations.push({
            yootOutcome4AlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome4AlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 1000
          })
        } else if (alerts[i] === 'yootOutcome5') {
          animations.push({
            yootOutcome5AlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcome5AlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 1000
          })
        } else if (alerts[i] === 'yootOutcome0') {
          animations.push({
            yootOutcomeOutAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcomeOutAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'yootOutcome-1' || alerts[i] === 'yootOutcome-1skip') {
          animations.push({
            yootOutcomeBackdoAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            yootOutcomeBackdoAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'pregameTie') {
          animations.push({
            pregameTieAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            pregameTieAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'pregameUfosWin') {
          animations.push({
            pregameUfosWinAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            pregameUfosWinAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'pregameRocketsWin') {
          animations.push({
            pregameRocketsWinAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            pregameRocketsWinAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i].includes('catch')) {
          const numCaught = parseInt(alerts[0][6]);
          const delay = 1000 + (numCaught > 2 ? 500 : 0)
          animations.push({
            catchAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            catchAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: delay
          })
        } else if (alerts[i].includes('score')) {
          const numScored = parseInt(alerts[0][6]);
          setScoringTeam(parseInt(alerts[0][5]))
          animations.push({
            scoreAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            scoreAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 800 + 350 * numScored
          })
        } else if (alerts[i].includes('join')) {
          animations.push({
            joinAlertScale: 1,
            config: {
                tension: 170,
                friction: 26,
                clamp: true
            },
          })
          animations.push({
            joinAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'timesUp') {
          animations.push({
            timesUpAlertScale: 1,
            config: {
                tension: 170,
                friction: 26
            },
          })
          animations.push({
            timesUpAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        } else if (alerts[i] === 'minigameTime') {
          animations.push({
            minigameTimeAlertScale: 1,
            config: {
                tension: 170,
                friction: 26
            },
          })
          animations.push({
            minigameTimeAlertScale: 0,
            config: {
                tension: 300,
                friction: 26,
                clamp: true
            },
            delay: 700
          })
        }
      }
      return animations
    }

    function launchScoreFireworks(team, numScored) {
      const hue = team === 0 ? 0.01 : 0.5

      if (numScored === 4) {
        // will go to 'win screen'
      } else if (numScored === 3) {
        // firework 1 - left
        const count = Math.round(700 + Math.random() * 400);
        const position = new THREE.Vector3(
            -4 + Math.random()*0.1, 
            0,
            -0.9 + Math.random()*0.2, 
        )

        const size = 0.25 + Math.random() * 0.1
        const radius = 1.0 + Math.random() * 0.2
        const color = new THREE.Color();
        color.setHSL(hue, 1, 0.6)

        CreateFirework({ count, position, size, radius, color });

        // firework 2 - right
        setTimeout(() => {
          // setting 2
          const count = Math.round(700 + Math.random() * 300);
          const position = new THREE.Vector3(
              4 + Math.random()*0.1, 
              0,
              -0.9 + Math.random()*0.2, 
          )
          const size = 0.3 + Math.random() * 0.09
          const radius = 1.0 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.6)
          CreateFirework({ count, position, size, radius, color });
        }, 220)

        // firework 3 - middle
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              0, 
              0,
              -1.9 + Math.random() * 0.1, 
          )
          const size = 0.25 + Math.random() * 0.08
          const radius = 1.2 + Math.random() * 0.4
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.6)
          CreateFirework({ count, position, size, radius, color });
        }, 500)

        // firework 4 - upper left
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              -1.3 + Math.random() * 0.1, 
              0,
              -4 + Math.random() * 0.1, 
          )
          const size = 0.3 + Math.random() * 0.1
          const radius = 1.3 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.55)
          CreateFirework({ count, position, size, radius, color });
        }, 900)

        // firework 5 - upper right
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              3 + Math.random() * 0.1, 
              0,
              -2.7 + Math.random() * 0.1, 
          )
          const size = 0.2 + Math.random() * 0.08
          const radius = 1.0 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.53)
          CreateFirework({ count, position, size, radius, color });
        }, 1000)

        // firework 6 - upper upper left
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              -5 + Math.random() * 0.3, 
              0,
              -5 + Math.random() * 0.3, 
          )
          const size = 0.15 + Math.random() * 0.04
          const radius = 1.0 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 0.4, 0.58)
          CreateFirework({ count, position, size, radius, color });
        }, 1210)

        // firework 7 
        setTimeout(() => {
          const count = Math.round(800 + Math.random() * 500);
          const position = new THREE.Vector3(
              1 + Math.random() * 0.3, 
              0,
              0.5 + Math.random() * 0.3, 
          )
          const size = 0.4 + Math.random() * 0.04
          const radius = 1 + Math.random() * 0.4
          const color = new THREE.Color();
          color.setHSL(hue, 0.8, 0.59)
          CreateFirework({ count, position, size, radius, color });
        }, 1500)

        // firework 8
        setTimeout(() => {
          const count = Math.round(800 + Math.random() * 500);
          const position = new THREE.Vector3(
              -2.4 + Math.random() * 0.3, 
              0,
              0.5 + Math.random() * 0.3, 
          )
          const size = 0.27 + Math.random() * 0.04
          const radius = 1.1 + Math.random() * 0.4
          const color = new THREE.Color();
          color.setHSL(hue, 1.0, 0.56)
          CreateFirework({ count, position, size, radius, color });
        }, 1650)
      } else if (numScored === 2) {
        // firework 1 - left
        const count = Math.round(700 + Math.random() * 400);
        const position = new THREE.Vector3(
            -4 + Math.random()*0.1, 
            0,
            -0.9 + Math.random()*0.2, 
        )

        const size = 0.5 + Math.random() * 0.04
        
        const radius = 1.0 + Math.random() * 0.2
        const color = new THREE.Color();
        color.setHSL(hue, 1, 0.59)

        CreateFirework({ count, position, size, radius, color });

        // firework 2 - right
        setTimeout(() => {
          // setting 2
          const count = Math.round(700 + Math.random() * 300);
          const position = new THREE.Vector3(
              3 + Math.random()*0.1, 
              0,
              -0.9 + Math.random()*0.2, 
          )
          const size = 0.5 + Math.random() * 0.04
          
          const radius = 1.0 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.57)
          CreateFirework({ count, position, size, radius, color });
        }, 200)

        // firework 3 - middle
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              -1, 
              0,
              -3 + Math.random() * 0.1, 
          )
          const size = 0.5 + Math.random() * 0.04
          
          const radius = 1.5 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.58)
          CreateFirework({ count, position, size, radius, color });
        }, 500)

        // firework 4 - upper left
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              1.7 + Math.random() * 0.2, 
              0,
              -4 + Math.random() * 0.2, 
          )
          const size = 0.4 + Math.random() * 0.04
          
          const radius = 1.1 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.59)
          CreateFirework({ count, position, size, radius, color });
        }, 900)
        
        // firework 5 - upper right
        setTimeout(() => {
          const count = Math.round(600 + Math.random() * 400);
          const position = new THREE.Vector3(
              1.5 + Math.random() * 0.2, 
              0,
              1.5 + Math.random() * 0.2, 
          )
          const size = 0.4 + Math.random() * 0.04
          
          const radius = 1.4 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.53)
          CreateFirework({ count, position, size, radius, color });
        }, 1100)
      } else if (numScored === 1) {
        // firework 1 - left
        const count = Math.round(700 + Math.random() * 400);
        const position = new THREE.Vector3(
            -4.0 + Math.random()*0.1, 
            0,
            -1.2 + Math.random()*0.2, 
        )

        const size = 0.4 + Math.random() * 0.07
        
        const radius = 1.2 + Math.random() * 0.2
        const color = new THREE.Color();
        color.setHSL(hue, 1, 0.6)

        CreateFirework({ count, position, size, radius, color });

        // firework 2 - right
        setTimeout(() => {
          // setting 2
          const count = Math.round(700 + Math.random() * 300);
          const position = new THREE.Vector3(
              4 + Math.random()*0.1, 
              0,
              -0.9 + Math.random()*0.2, 
          )
          const size = 0.5 + Math.random() * 0.07
          
          const radius = 1.2 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.6)
          CreateFirework({ count, position, size, radius, color });
        }, 500)

        // firework 3 - middle
        setTimeout(() => {
          const count = Math.round(800 + Math.random() * 400);
          const position = new THREE.Vector3(
              0, 
              0,
              -3 + Math.random() * 0.1, 
          )
          const size = 0.5 + Math.random() * 0.07
          
          const radius = 1.4 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.6)
          CreateFirework({ count, position, size, radius, color });
        }, 1000)

        
        // firework 4 - middle
        setTimeout(() => {
          const count = Math.round(800 + Math.random() * 400);
          const position = new THREE.Vector3(
              2, 
              0,
              -2.5 + Math.random() * 0.1, 
          )
          const size = 0.5 + Math.random() * 0.07
          
          const radius = 1.4 + Math.random() * 0.2
          const color = new THREE.Color();
          color.setHSL(hue, 1, 0.6)
          CreateFirework({ count, position, size, radius, color });
        }, 1200)
      }
    }

    useEffect(() => {
      const toAnimations = transformAlertsToAnimations(alerts)
      if (!animationPlaying) {
        api.start({
          from: {
            turnAlertScale: 0,
            gameStartAlertScale: 0,
            yootOutcome1AlertScale: 0,
            yootOutcome2AlertScale: 0,
            yootOutcome3AlertScale: 0,
            yootOutcome4PregameAlertScale: 0,
            yootOutcome5PregameAlertScale: 0,
            yootOutcome4AlertScale: 0,
            yootOutcome5AlertScale: 0,
            yootOutcomeOutAlertScale: 0,
            yootOutcomeBackdoAlertScale: 0,
            pregameTieAlertScale: 0,
            pregameUfosWinAlertScale: 0,
            catchAlertScale: 0,
            scoreAlertScale: 0,
            joinAlertScale: 0,
            timesUpAlertScale: 0,
            minigameTimeAlertScale: 0
          },
          to: alerts.length > 0 ? toAnimations : [],
          loop: false,
          onStart: () => {},
          onRest: () => {} // plays twice when browser is not in focus
        })
        
        // if I add it in 'onStart' it will trigger on every element of the 'to' array
        if (alerts[0] && alerts[0].includes('score')) {
          const team = parseInt(alerts[0][5]);
          const numScored = parseInt(alerts[0][6]);
          launchScoreFireworks(team, numScored)
        } else if (alerts[0] && alerts[0].includes('join')) {
        }
      }
    }, [alerts, animationPlaying])



    function YootOutcome1Alert() {
      return <animated.group scale={springs.yootOutcome1AlertScale}>
        <DoAlert/>
      </animated.group>
    }
    function YootOutcome2Alert() {
      return <animated.group scale={springs.yootOutcome2AlertScale}>
        <GeAlert/>
      </animated.group>
    }
    function YootOutcome3Alert() {
      return <animated.group scale={springs.yootOutcome3AlertScale}>
        <GulAlert/>
      </animated.group>
    }
    function YootOutcome4PregameAlert() {
      return <animated.group scale={springs.yootOutcome4PregameAlertScale}>
        <YootAlertPregame/>
      </animated.group>
    }
    function YootOutcome5PregameAlert() {
      return <animated.group scale={springs.yootOutcome5PregameAlertScale}>
        <MoAlertPregame/>
      </animated.group>
    }
    function YootOutcome4Alert() {
      return <animated.group scale={springs.yootOutcome4AlertScale}>
        <YootAlert/>
      </animated.group>
    }
    function YootOutcome5Alert() {
      return <animated.group scale={springs.yootOutcome5AlertScale} > 
        <MoAlert/>
      </animated.group>
    }
    function YootOutcomeOutAlert() {
      return <animated.group scale={springs.yootOutcomeOutAlertScale}>
        <OutAlert/>
      </animated.group>
    }
    function YootOutcomeBackdoAlert() {
      const skip = alerts.includes('yootOutcome-1skip');
      return <animated.group scale={springs.yootOutcomeBackdoAlertScale}>
        <BackdoAlert gamePhase={gamePhase} skip={skip}/>
      </animated.group>
    }

    function CatchAlert() { // refactor like score alert with substring matching
      const teamCaught = alerts[0] && parseInt(alerts[0][5]);
      const numCaught = alerts[0] && parseInt(alerts[0][6]);
      const noBonus = !!(alerts[0] && (parseInt(alerts[0][7]) === 4 || parseInt(alerts[0][7]) === 5) && !yutMoCatch);
      return <animated.group scale={springs.catchAlertScale}>
        { numCaught === 1 && teamCaught === 0 && <CatchRocketMemeAlert bonus={!noBonus} /> }
        {/* { numCaught === 1 && teamCaught === 0 && <Catch1RocketAlert/> } */}
        { numCaught === 2 && teamCaught === 0 && <CatchRocketMemeAlert bonus={!noBonus}/> }
        { numCaught === 3 && teamCaught === 0 && <CatchRocketMemeAlert bonus={!noBonus}/> }
        { numCaught === 4 && teamCaught === 0 && <CatchRocketMemeAlert bonus={!noBonus}/> }
        { numCaught === 1 && teamCaught === 1 && <Catch3UfoAlert bonus={!noBonus}/> }
        {/* { numCaught === 1 && teamCaught === 1 && <Catch3UfoAlert/> } */}
        {/* { numCaught === 1 && teamCaught === 1 && <Catch1UfoAlert/> } */}
        { numCaught === 2 && teamCaught === 1 && <Catch3UfoAlert bonus={!noBonus}/> }
        { numCaught === 3 && teamCaught === 1 && <Catch3UfoAlert bonus={!noBonus}/> }
        { numCaught === 4 && teamCaught === 1 && <Catch3UfoAlert bonus={!noBonus}/> }
        {/* { numCaught === 1 && teamCaught === 1 && <CatchUfoEnergyAlert/> }
        { numCaught === 2 && teamCaught === 1 && <CatchUfoEnergyAlert/> }
        { numCaught === 3 && teamCaught === 1 && <CatchUfoEnergyAlert/> }
        { numCaught === 4 && teamCaught === 1 && <CatchUfoEnergyAlert/> } */}
      </animated.group>
    }

    function TurnAlertGame() {
      const currentPlayerName = useAtomValue(currentPlayerNameAtom)
      return <animated.group scale={springs.turnAlertScale}>
        <TurnAlert name={currentPlayerName}/>
      </animated.group>
    }

    function handleAlertPointerDown(e) {
      e.stopPropagation()
        api.start({
          from: {
            turnAlertScale: 0,
            gameStartAlertScale: 0,
            yootOutcome1AlertScale: 0,
            yootOutcome2AlertScale: 0,
            yootOutcome3AlertScale: 0,
            yootOutcome4PregameAlertScale: 0,
            yootOutcome5PregameAlertScale: 0,
            yootOutcome4AlertScale: 0,
            yootOutcome5AlertScale: 0,
            yootOutcomeOutAlertScale: 0,
            yootOutcomeBackdoAlertScale: 0,
            pregameTieAlertScale: 0,
            pregameUfosWinAlertScale: 0,
            catchAlertScale: 0,
            scoreAlertScale: 0,
            joinAlertScale: 0,
            timesUpAlertScale: 0
          },
          to: [
            {
              turnAlertScale: 0,
              gameStartAlertScale: 0,
              yootOutcome1AlertScale: 0,
              yootOutcome2AlertScale: 0,
              yootOutcome3AlertScale: 0,
              yootOutcome4PregameAlertScale: 0,
              yootOutcome5PregameAlertScale: 0,
              yootOutcome4AlertScale: 0,
              yootOutcome5AlertScale: 0,
              yootOutcomeOutAlertScale: 0,
              yootOutcomeBackdoAlertScale: 0,
              pregameTieAlertScale: 0,
              pregameUfosWinAlertScale: 0,
              catchAlertScale: 0,
              scoreAlertScale: 0,
              joinAlertScale: 0,
              timesUpAlertScale: 0,
              minigameTimeAlertScale: 0
            },
          ],
          loop: false,
          onStart: () => {},
          onRest: () => {} // plays twice when browser is not in focus
        })
    }

    return (gamePhase === 'pregame' || gamePhase === 'game') && <group 
      position={position} 
      rotation={rotation}
      onPointerDown={e=>handleAlertPointerDown(e)}
    >
      {/* refactored to use with Showroom */}
      <TurnAlertGame/>
      <GameStartAlert scale={springs.gameStartAlertScale}/>
      <PregameTieAlert scale={springs.pregameTieAlertScale}/>
      <PregameRocketsWinAlert scale={springs.pregameRocketsWinAlertScale}/>
      <PregameUfosWinAlert scale={springs.pregameUfosWinAlertScale}/>
      <YootOutcome1Alert/>
      <YootOutcome2Alert/>
      <YootOutcome3Alert/>
      <YootOutcome4PregameAlert/>
      <YootOutcome5PregameAlert/>
      <YootOutcome4Alert/>
      <YootOutcome5Alert/>
      <YootOutcomeOutAlert/>
      <YootOutcomeBackdoAlert/>
      <CatchAlert/>
      <ScoreAlert scale={springs.scoreAlertScale} scoringTeam={scoringTeam}/>
      <JoinAlert scale={springs.joinAlertScale} />
      <TimesUpAlert scale={springs.timesUpAlertScale}/>
      <MinigameTimeAlert scale={springs.minigameTimeAlertScale}/>
    </group>
  }